import { connect } from 'react-redux';

import { setRateChapterQuestionsReport } from '../../Bibliographies/actions';
import { loadReportSaga } from '../../Bibliographies/actionsSagas';
import {
  getRateChapterQuestionsReport,
  loadingGrid,
} from '../../Bibliographies/selectors';
import { loadRates } from '../../Rates/actionsSagas';
import { getRates, getWaiting } from '../../Rates/selectors';
import {
  generateAssignedToWritersReport,
  generateAudioAbbreviationsReport,
  generateAudioReport,
  generateBooksMissingAnswersReport,
  generateFavoriteQuestionsReport,
  generateIntercomActiveUsersReport,
  generateRateQuestionsReport,
  generateReferredLeadsReport,
  generateSelfPromotionReport,
  generateSubscriptionTypesReport,
  generateUsageReport,
  getAudioReports,
  getBibliographyReportForGivenRates,
  getLastFavoriteQuestionsReports as getLastFavoriteQuestionsReportsAction,
  getLastRateQuestionsReports as getLastRateQuestionsReportsAction,
  getLatestAssignedToWritersReport,
  getLatestAudioAbbreviationsReport,
  getLatestBooksMissingAnswersReport,
  getLatestIntercomActiveUsersReport,
  getLatestReferredLeadsReport,
  getLatestSelfPromotionReport,
  getSubscriptionTypesReports as getSubscriptionTypesReportsAction,
  getUsageReports,
  getUsersCount,
  getUserSubmittedQuestionsReportForGivenRates,
  setCompletionStatus,
  setGraphSagas,
  setUserSubmittedQuestionsReport,
} from '../actions';
import { getCompletionStatusSagas } from '../actionsSagas';
import {
  getAssignedToWritersReportData,
  getAssignedToWritersReportState,
  getAudioAbbreviationReport,
  getAudioReportsData,
  getAudioReportsState,
  getBibliographyCSVJsonReport,
  getBibliographyReportError,
  getBibliographyReportIsLoading,
  getBooksMissingAnswersReportData,
  getBooksMissingAnswersReportState,
  getCompletionStatus,
  getGraph,
  getIntercomActiveUsersReport,
  getIsUserSubmittedQuestionsReportLoading,
  getLastFavoriteQuestionsReports,
  getLastRateQuestionsReports,
  getLoadingFavoriteQuestionsReport,
  getReferredLeadsReportData,
  getReferredLeadsReportState,
  getSelfPromotionReportData,
  getSelfPromotionReportState,
  getSubscriptionTypesReports,
  getSubscriptionTypesReportsIsLoading,
  getUsageStatisticsReports,
  getUsageStatisticsReportsIsLoading,
  getUsersCountData,
  getUsersReportIsLoading,
  getUserSubmittedQuestionsReportCSVJson,
  getUserSubmittedQuestionsReportError,
} from '../selectors';
import Reports from './Reports';

const mapStateToProps = (state) => ({
  report: getRateChapterQuestionsReport(state),
  isLoading: loadingGrid(state),
  ratesIsLoading: getWaiting(state),
  rates: getRates(state),
  /* All CSV Bibliography Data Report */
  bibliographyReport: getBibliographyCSVJsonReport(state),
  bibliographyReportIsLoading: getBibliographyReportIsLoading(state),
  bibliographyReportError: getBibliographyReportError(state),
  /* Users Report */
  usersReportIsLoading: getUsersReportIsLoading(state),
  usersCount: getUsersCountData(state),
  graph: getGraph(state),
  /* Completion Status Report */
  completionStatus: getCompletionStatus(state),
  /* User Submitted Questions Report */
  userSubmittedQuestionsReport: getUserSubmittedQuestionsReportCSVJson(state),
  isUserSubmittedQuestionsReportLoading:
    getIsUserSubmittedQuestionsReportLoading(state),
  userSubmittedQuestionsReportError:
    getUserSubmittedQuestionsReportError(state),
  /* Favorite questions Report */
  lastFavoriteQuestionsReports: getLastFavoriteQuestionsReports(state),
  loadingFavoriteQuestionsReport: getLoadingFavoriteQuestionsReport(state),
  /* Rate questions Report */
  lastRateQuestionsReports: getLastRateQuestionsReports(state),
  // rateQuestionsReportIsLoading={this.props.favoriteQuestionsReportIsLoading}
  /* Usage Statistics Report */
  usageStatisticsReports: getUsageStatisticsReports(state),
  usageStatisticsReportsIsLoading: getUsageStatisticsReportsIsLoading(state),
  /* Subscription Types Report */
  subscriptionTypesReports: getSubscriptionTypesReports(state),
  subscriptionTypesReportsIsLoading:
    getSubscriptionTypesReportsIsLoading(state),
  /* Books missing answers report */
  booksMissingAnswersReportData: getBooksMissingAnswersReportData(state),
  booksMissingAnswersReportState: getBooksMissingAnswersReportState(state),
  /* Audio Report */
  audioReportsData: getAudioReportsData(state),
  audioReportsState: getAudioReportsState(state),
  /* AudioAbbreviation Report */
  audioAbbreviationReport: getAudioAbbreviationReport(state),
  /* Referral Leads Report */
  referredLeadsReportData: getReferredLeadsReportData(state),
  referredLeadsReportState: getReferredLeadsReportState(state),
  /* Assigned To Writers Report */
  assignedToWritersReportData: getAssignedToWritersReportData(state),
  assignedToWritersReportState: getAssignedToWritersReportState(state),
  /* Intercom Active Users Report */
  intercomActiveUsersReport: getIntercomActiveUsersReport(state),
  /* Self Promotion Status Report */
  selfPromotionReportData: getSelfPromotionReportData(state),
  selfPromotionReportState: getSelfPromotionReportState(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadRates: () => {
    dispatch(loadRates());
  },
  downloadReport: (report) => {
    dispatch(loadReportSaga(report));
  },
  onClearReport: () => {
    dispatch(setRateChapterQuestionsReport());
  },

  /* All CSV Bibliography Data Report */
  getBibliographyReportForGivenRates: (rates, ratingExams, multiple) => {
    dispatch(getBibliographyReportForGivenRates(rates, ratingExams, multiple));
  },
  /* Users Report */
  getUsersCount: (query) => {
    dispatch(getUsersCount(query));
  },
  setGraph: (graph) => {
    dispatch(setGraphSagas(graph));
  },
  /* Completion Status Report */
  setCompletionStatus: (data) => {
    dispatch(setCompletionStatus(data));
  },
  getCompletionStatusSagas: () => {
    dispatch(getCompletionStatusSagas());
  },
  /* User Submitted Questions Report */
  getUserSubmittedQuestionsReportForGivenRates: (rates) => {
    dispatch(getUserSubmittedQuestionsReportForGivenRates(rates));
  },
  setUserSubmittedQuestionsReport: (data) => {
    dispatch(setUserSubmittedQuestionsReport(data));
  },
  /* Favorite questions Report */
  generateFavoriteQuestionsReport: (ratesIds, ratingExams) => {
    dispatch(generateFavoriteQuestionsReport(ratesIds, ratingExams));
  },
  getLastFavoriteQuestionsReports: () => {
    dispatch(getLastFavoriteQuestionsReportsAction());
  },
  /* Rate questions Report */
  generateRateQuestionsReport: (ratesIds) => {
    dispatch(generateRateQuestionsReport(ratesIds));
  },
  getLastRateQuestionsReports: () => {
    dispatch(getLastRateQuestionsReportsAction());
  },
  /* Usage Statistics Report */
  generateUsageReport: (
    fromDate,
    untilDate,
    fromDateComparison,
    untilDateComparison,
  ) => {
    dispatch(
      generateUsageReport(
        fromDate,
        untilDate,
        fromDateComparison,
        untilDateComparison,
      ),
    );
  },
  getUsageReports: () => {
    dispatch(getUsageReports());
  },
  /* Subscription Types Report */
  generateSubscriptionTypesReport: (
    fromDate,
    untilDate,
    fromDateComparison,
    untilDateComparison,
  ) => {
    dispatch(
      generateSubscriptionTypesReport(
        fromDate,
        untilDate,
        fromDateComparison,
        untilDateComparison,
      ),
    );
  },
  getSubscriptionTypesReports: () => {
    dispatch(getSubscriptionTypesReportsAction());
  },
  /* Books missing answers report */
  generateBooksMissingAnswersReport: () => {
    dispatch(generateBooksMissingAnswersReport());
  },
  getLatestBooksMissingAnswersReport: () => {
    dispatch(getLatestBooksMissingAnswersReport());
  },
  /* Audio Report */
  generateAudioReport: (rate) => {
    dispatch(generateAudioReport(rate));
  },
  getAudioReports: () => {
    dispatch(getAudioReports());
  },
  /* Audio Abbreviation Report */
  generateAudioAbbreviationsReport: () => {
    dispatch(generateAudioAbbreviationsReport());
  },
  getLatestAudioAbbreviationsReport: () => {
    dispatch(getLatestAudioAbbreviationsReport());
  },
  /* Referral Leads Report */
  generateReferredLeadsReport: () => {
    dispatch(generateReferredLeadsReport());
  },
  getLatestReferredLeadsReport: () => {
    dispatch(getLatestReferredLeadsReport());
  },
  /* Assigned To Writers Report */
  generateAssignedToWritersReport: () => {
    dispatch(generateAssignedToWritersReport());
  },
  getLatestAssignedToWritersReport: () => {
    dispatch(getLatestAssignedToWritersReport());
  },
  /* Intercom Active Users Report */
  generateIntercomActiveUsersReport: () => {
    dispatch(generateIntercomActiveUsersReport());
  },
  getLatestIntercomActiveUsersReport: () => {
    dispatch(getLatestIntercomActiveUsersReport());
  },
  /* Self Promotion Status Report */
  generateSelfPromotionReport: () => {
    dispatch(generateSelfPromotionReport());
  },
  getLatestSelfPromotionReport: () => {
    dispatch(getLatestSelfPromotionReport());
  },
});

const ReportsContainer = connect(mapStateToProps, mapDispatchToProps)(Reports);

export default ReportsContainer;
